import { faEdit, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import Table from "../../../Components/Table";
import LeiaMais from "../../../Components/Utils/LeiaMais";
import { RemoverTemplateMensagemAtivaController } from "../../../Controllers/HelpDesk/GestaoTemplate/GestaoTemplateController";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import { IMensagemTemplate } from "../../../Interfaces/HelpDesk/Equipes/Atendimento/AtendimentoInterfaces";
import { ListarMensagensTemplate } from "../../../Services/HelpDesk/GestaoAtendimentos/GestaoAtendimentosService";

export default function GestaoTemplateHelpdesk() {
    const {
        value: lstMensagensTemplate,
        loading: lstMensagensTemplateLoading,
        execute: updateList,
    } = useAsyncEffect(() => ListarMensagensTemplate());

    function RowTable(cell: any, row: IMensagemTemplate) {
        return (
            <>
                <div className="rowCapys">
                    <div className="py-3">
                        <h2>{row.DS_NOME_TEMPLATE ?? ""}</h2>
                        <span className="font-weight-bolder">
                            <LeiaMais charLimit={100}>
                                {row.DS_CORPO_TEMPLATE}
                            </LeiaMais>
                        </span>
                    </div>
                    <div className="d-flex flex-row">
                        <div className="Button-Tools pt-3">
                            <Link
                                to={`/HelpDesk/GestaoTemplates/ConfigurarTemplates/${row.ID_DOCUMENTO_TEMPLATE}`}
                                className="btn btn-outline-primary font-weight-bold mr-2"
                            >
                                <FontAwesomeIcon icon={faEdit} size="lg" />{" "}
                                Editar
                            </Link>
                        </div>
                        <div className="Button-Tools pt-3">
                            <button
                                className="btn btn-outline-danger font-weight-bold mr-2"
                                type="button"
                                onClick={() => {
                                    Swal.fire({
                                        title: `Deseja apagar o ${row.DS_NOME_TEMPLATE}?`,
                                        icon: "info",
                                        buttonsStyling: false,
                                        confirmButtonText:
                                            "<i class='la la-check'></i> Sim!",
                                        showCancelButton: true,
                                        cancelButtonText:
                                            "<i class='la la-thumbs-down'></i> Não",
                                        customClass: {
                                            confirmButton:
                                                "btn btn-outline-success",
                                            cancelButton: "btn btn-default",
                                        },
                                    }).then((result) => {
                                        if (result) {
                                            RemoverTemplateMensagemAtivaController(
                                                row.ID_DOCUMENTO_TEMPLATE
                                            ).then(() => {
                                                updateList();
                                            });
                                        }
                                    });
                                }}
                            >
                                <FontAwesomeIcon icon={faTrash} size="lg" />{" "}
                                Excluir
                            </button>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    const column = [
        {
            dataField: "DS_NOME_TEMPLATE",
            text: "Descrição",
            formatter: RowTable,
            sort: true,
        },
    ];

    return (
        <>
            <div className="card card-custom">
                <div className="card-header card-header-tabs-line d-flex align-items-center">
                    <h3 className="card-title align-items-start ">
                        <span className="card-label font-weight-bolder text-dark gruposTitle">
                            Gestão de Templates
                        </span>
                    </h3>
                    <div className="card-toolbar">
                        <Link
                            to={`/HelpDesk/GestaoTemplates/ConfigurarTemplates/0`}
                            className="btn btn-success font-weight-bold mr-2 linkSemIcone"
                        >
                            <FontAwesomeIcon icon={faPlus} className="mr-2" />
                            Cadastrar Template
                        </Link>
                    </div>
                </div>
                <div className="card-body">
                    <Table
                        data={lstMensagensTemplate?.data ?? []}
                        loading={lstMensagensTemplateLoading}
                        bordered={false}
                        striped
                        columns={column}
                        keyField="ID_DOCUMENTO_TEMPLATE"
                        center
                        noSearch
                    />
                </div>
            </div>
        </>
    );
}
